(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollHints(root) {
    var rows = (root || document).querySelectorAll('[data-pet-scroll-hint]');
    rows.forEach(function (row) {
      if (row.dataset.petScrollReady === 'true') return;
      row.dataset.petScrollReady = 'true';

      var hint = row.parentElement && row.parentElement.querySelector('.pet-scroll-hint');
      if (!hint) return;

      function updateHint() {
        var canScroll = row.scrollWidth > row.clientWidth + 8;
        hint.hidden = !canScroll || row.scrollLeft > 24;
      }

      row.addEventListener('scroll', updateHint, { passive: true });
      window.addEventListener('resize', updateHint);
      updateHint();
    });
  }

  function initAccordions(root) {
    var buttons = (root || document).querySelectorAll('[data-pet-accordion-button]');
    buttons.forEach(function (button) {
      if (button.dataset.petAccordionReady === 'true') return;
      button.dataset.petAccordionReady = 'true';
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  function initStickyAtc(root) {
    var sticky = (root || document).querySelector('[data-pet-sticky-atc-phase29]');
    var submit = (root || document).querySelector('[data-pet-main-atc]');
    if (!sticky || !submit || sticky.dataset.petStickyReady === 'true') return;
    sticky.dataset.petStickyReady = 'true';
    sticky.classList.add('pet-sticky-atc--ready');

    var stickyButton = sticky.querySelector('button');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        submit.click();
      });
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var isSubmitVisible = true;
    var hasSeenSubmit = false;

    function updateSticky() {
      sticky.classList.toggle('is-visible', hasSeenSubmit && !isSubmitVisible);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isSubmitVisible = entry.isIntersecting;
        if (entry.isIntersecting) {
          hasSeenSubmit = true;
        }
        updateSticky();
      });
    }, { threshold: 0.1 });

    observer.observe(submit);
    updateSticky();
  }

  function initFade(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.pet-fade').forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    (root || document).querySelectorAll('.pet-fade').forEach(function (item) {
      observer.observe(item);
    });
  }

  function init(root) {
    initScrollHints(root);
    initAccordions(root);
    initStickyAtc(root);
    initFade(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
